import Layout from '../../layout/Dashboard';
import Heading from '../../components/Heading';
import TabMenu from '../../components/TabMenu';
import Loading from '../../components/Loading';
import WeekCalendar from '../../components/WeekCalendar';
import useToggleTheme from '../../hooks/useToggleTheme';
import useDashboard, { tabMenu } from '../../hooks/useDashboard';
import { useAppSelector } from '../../redux/hooks';
import { parseHolidaysToDbDate } from '../../utils/date';

import TradingVolume from './components/TradingVolume';
import TradingValue from './components/TradingValue';
import Top10Increase from './components/Top10Increase';
import Top10Lowest from './components/Top10Lowest';
import Top10TradingValue from './components/Top10TradingValue';
import Top10TradingVolume from './components/Top10TradingVolume';
import TradingVolumeBySector from './components/TradingVolumeBySector';
import TradingValueBySector from './components/TradingValueBySector';
import Top5NegotiableTradingValue from './components/Top5NegotiableTradingValue';
import Top5NegotiableTradingVolume from './components/Top5NegotiableTradingVolume';
import HighlightByStockUp from './components/HighlightByStockUp';
import MarketNewsSection from './components/MarketNewsSection';
import SectorTrending from './components/SectorTrending';
import CapChart from './components/CapChart';
import HighlightStockBySector from './components/HighlightStockBySector';
import * as Styles from './Dashboard.styles';
import useInvestmentCategories from '../../hooks/useInvestmentCategories';

const Dashboard = () => {
  const { isDarkMode } = useToggleTheme();
  const {
    isTop10TradingValueLoading,
    top10TradingValueData,
    isTop10TradingVolumeLoading,
    top10TradingVolumeData,
    isTop10IncreaseLoading,
    topTop10IncreaseData,
    isTop10LowestLoading,
    topTop10LowestData,
    selectedStock,
    selectedDate,
    endDate,
    startDate,
    isTradingValueBySectorLoading,
    topTradingValueBySectorData,
    isTradingVolumeBySectorLoading,
    topTradingVolumeBySectorData,
    isTop5TransferValueLoading,
    topTop5TransferValueData,
    isTop5TradingVolumeLoading,
    topTop5TradingVolumeData,
    isTradingVolumeLargeCapLoading,
    tradingVolumeLargeCapData,
    isTradingVolumeMidCapLoading,
    tradingVolumeMidCapData,
    isTradingVolumeSmallCapLoading,
    tradingVolumeSmallCapData,
    isTradingVolumeMicroCapLoading,
    tradingVolumeMicroCapData,
    isTradingValueLargeCapLoading,
    tradingValueLargeCapData,
    isTradingValueMidCapLoading,
    tradingValueMidCapData,
    isTradingValueSmallCapLoading,
    tradingValueSmallCapData,
    isTradingValueMicroCapLoading,
    tradingValueMicroCapData,
    isAppLoading,
    handleTabChange,
    handleDateChange,
    tradingVolumeChartType,
    setTradingVolumeChartType,
    tradingValueChartType,
    setTradingValueChartType,
    tradingVolumeHistory,
    isTradingVolumeHistoryLoading,
    tradingValueHistory,
    isTradingValueHistoryLoading,
    isTop10GoUpLoading,
    top10GoUpData,
    isTop10GoDownLoading,
    top10GoDownData,
    handlePeriodClick,
    selectedPeriod,
    isTradingVolumeChartLoading,
    tradingValueChartData,
    tradingVolumeChartData,
    isTradingValueChartLoading,
    handleOpenTop10Tooltip,
    chartDataByCode,
    handlesSelectedChartPeriodChange,
    selectedChartPeriod,
    setSelectedDataChartModal,
    setChartModalShow,
    isChartDataByCodeLoading,
    setSelectedChartPeriod,
    tradingVolumeExchangeHistoryChartData,
    tradingValueExchangeHistoryChartData,
    marketNews,
    isMarketNewsLoading,
    upTrendingData,
    isUpTrendingDataLoading,
    handleMonthChange,
    sectorTrendingDate,
  } = useDashboard();
  const {
    isInvestmentCategoriesLoading,
    authenticated,
    investmentCategories,
    followCompanies,
    saveInvestmentCategory,
    deleteInvestmentCategory,
    investmentCategoriesMessage,
    isOpeningBookmark,
    handleSetIsOpeningBookmark,
  } = useInvestmentCategories();
  const { appInfo } = useAppSelector((state) => state.appInfo);

  return (
    <Layout>
      <Styles.Wrapper>
        <div className="flex justify-between items-start flex-col md:flex-row">
          <div className="flex flex-col">
            <Heading classNames="mb-0 page-title">
              Thống Kê Thị Trường Chứng Khoán
            </Heading>
            <div className="mt-3 relative">
              {!isAppLoading ? (
                <WeekCalendar
                  currentDate={selectedDate}
                  onChange={handleDateChange}
                  maxDate={endDate}
                  minDate={startDate}
                  holidays={appInfo?.holidays?.map((val) =>
                    parseHolidaysToDbDate(val)
                  )}
                />
              ) : null}
              <Loading isLoading={isAppLoading} small isHorizontal />
            </div>
          </div>
          <div className="mt-4 md:mt-0.5 relative">
            <Loading
              isLoading={isAppLoading}
              small
              extend
              isHorizontal
              className="bg-gray-50"
            />
            <div className="flex items-center justify-end">
              <TabMenu
                options={tabMenu}
                onChange={handleTabChange}
                defaultValue={selectedStock}
                nowrap
                className="tab-menu order-1 sm:order-2"
              />
            </div>
          </div>
        </div>
        <div className="mt-5">
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 mt-6">
            <TradingVolume
              isDarkMode={isDarkMode}
              isLoading={isTradingVolumeHistoryLoading}
              exchangeHistory={tradingVolumeHistory}
              selectedStock={selectedStock}
              handlePeriodClick={handlePeriodClick}
              selectedPeriod={selectedPeriod.volume}
              isTradingVolumeChartLoading={isTradingVolumeChartLoading}
              tradingChartData={tradingVolumeChartData}
            />
            <TradingValue
              isDarkMode={isDarkMode}
              isLoading={isTradingValueHistoryLoading}
              exchangeHistory={tradingValueHistory}
              selectedStock={selectedStock}
              handlePeriodClick={handlePeriodClick}
              selectedPeriod={selectedPeriod.value}
              isTradingValueChartLoading={isTradingValueChartLoading}
              tradingChartData={tradingValueChartData}
            />
          </div>
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 xl:grid-cols-4 mt-6">
            <Top10Increase
              isLoading={isTop10IncreaseLoading}
              data={topTop10IncreaseData}
              isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
              authenticated={authenticated}
              investmentCategories={investmentCategories}
              followCompanies={followCompanies}
              saveInvestmentCategory={saveInvestmentCategory}
              deleteInvestmentCategory={deleteInvestmentCategory}
              investmentCategoriesMessage={investmentCategoriesMessage}
              isOpeningBookmark={isOpeningBookmark}
              handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
              isDarkMode={isDarkMode}
              handleTooltipOpen={handleOpenTop10Tooltip}
              top10ChartData={chartDataByCode}
              setSelectedChartPeriod={setSelectedChartPeriod}
              handlesSelectedChartPeriodChange={
                handlesSelectedChartPeriodChange
              }
              selectedChartPeriod={selectedChartPeriod}
              setSelectedDataChartModal={setSelectedDataChartModal}
              setChartModalShow={setChartModalShow}
              isChartDataByCodeLoading={isChartDataByCodeLoading}
            />
            <Top10Lowest
              isLoading={isTop10LowestLoading}
              data={topTop10LowestData}
              isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
              authenticated={authenticated}
              investmentCategories={investmentCategories}
              followCompanies={followCompanies}
              saveInvestmentCategory={saveInvestmentCategory}
              deleteInvestmentCategory={deleteInvestmentCategory}
              investmentCategoriesMessage={investmentCategoriesMessage}
              isOpeningBookmark={isOpeningBookmark}
              handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
              isDarkMode={isDarkMode}
              handleTooltipOpen={handleOpenTop10Tooltip}
              top10ChartData={chartDataByCode}
              setSelectedChartPeriod={setSelectedChartPeriod}
              handlesSelectedChartPeriodChange={
                handlesSelectedChartPeriodChange
              }
              selectedChartPeriod={selectedChartPeriod}
              setSelectedDataChartModal={setSelectedDataChartModal}
              setChartModalShow={setChartModalShow}
              isChartDataByCodeLoading={isChartDataByCodeLoading}
            />
            <Top10TradingValue
              isLoading={isTop10TradingValueLoading}
              data={top10TradingValueData}
              isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
              authenticated={authenticated}
              investmentCategories={investmentCategories}
              followCompanies={followCompanies}
              saveInvestmentCategory={saveInvestmentCategory}
              deleteInvestmentCategory={deleteInvestmentCategory}
              investmentCategoriesMessage={investmentCategoriesMessage}
              isOpeningBookmark={isOpeningBookmark}
              handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
              isDarkMode={isDarkMode}
              handleTooltipOpen={handleOpenTop10Tooltip}
              top10ChartData={chartDataByCode}
              setSelectedChartPeriod={setSelectedChartPeriod}
              handlesSelectedChartPeriodChange={
                handlesSelectedChartPeriodChange
              }
              selectedChartPeriod={selectedChartPeriod}
              setSelectedDataChartModal={setSelectedDataChartModal}
              setChartModalShow={setChartModalShow}
              isChartDataByCodeLoading={isChartDataByCodeLoading}
            />
            <Top10TradingVolume
              isLoading={isTop10TradingVolumeLoading}
              data={top10TradingVolumeData}
              isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
              authenticated={authenticated}
              investmentCategories={investmentCategories}
              followCompanies={followCompanies}
              saveInvestmentCategory={saveInvestmentCategory}
              deleteInvestmentCategory={deleteInvestmentCategory}
              investmentCategoriesMessage={investmentCategoriesMessage}
              isOpeningBookmark={isOpeningBookmark}
              handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
              isDarkMode={isDarkMode}
              handleTooltipOpen={handleOpenTop10Tooltip}
              top10ChartData={chartDataByCode}
              setSelectedChartPeriod={setSelectedChartPeriod}
              handlesSelectedChartPeriodChange={
                handlesSelectedChartPeriodChange
              }
              selectedChartPeriod={selectedChartPeriod}
              setSelectedDataChartModal={setSelectedDataChartModal}
              setChartModalShow={setChartModalShow}
              isChartDataByCodeLoading={isChartDataByCodeLoading}
            />
          </div>
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 mt-6">
            <Top5NegotiableTradingVolume
              isLoading={isTop5TradingVolumeLoading}
              data={topTop5TradingVolumeData}
              isDarkMode={isDarkMode}
              handleTooltipOpen={handleOpenTop10Tooltip}
              isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
              authenticated={authenticated}
              investmentCategories={investmentCategories}
              followCompanies={followCompanies}
              saveInvestmentCategory={saveInvestmentCategory}
              deleteInvestmentCategory={deleteInvestmentCategory}
              investmentCategoriesMessage={investmentCategoriesMessage}
              isOpeningBookmark={isOpeningBookmark}
              handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
              top5ChartData={chartDataByCode}
              setSelectedChartPeriod={setSelectedChartPeriod}
              handlesSelectedChartPeriodChange={
                handlesSelectedChartPeriodChange
              }
              selectedChartPeriod={selectedChartPeriod}
              setSelectedDataChartModal={setSelectedDataChartModal}
              setChartModalShow={setChartModalShow}
              isChartDataByCodeLoading={isChartDataByCodeLoading}
            />
            <Top5NegotiableTradingValue
              isLoading={isTop5TransferValueLoading}
              data={topTop5TransferValueData}
              isDarkMode={isDarkMode}
              handleTooltipOpen={handleOpenTop10Tooltip}
              isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
              authenticated={authenticated}
              investmentCategories={investmentCategories}
              followCompanies={followCompanies}
              saveInvestmentCategory={saveInvestmentCategory}
              deleteInvestmentCategory={deleteInvestmentCategory}
              investmentCategoriesMessage={investmentCategoriesMessage}
              isOpeningBookmark={isOpeningBookmark}
              handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
              top5ChartData={chartDataByCode}
              setSelectedChartPeriod={setSelectedChartPeriod}
              handlesSelectedChartPeriodChange={
                handlesSelectedChartPeriodChange
              }
              selectedChartPeriod={selectedChartPeriod}
              setSelectedDataChartModal={setSelectedDataChartModal}
              setChartModalShow={setChartModalShow}
              isChartDataByCodeLoading={isChartDataByCodeLoading}
            />
          </div>
          <div className="w-full mt-6">
            <CapChart
              tradingVolumeLargeCap={{
                isTradingVolumeLargeCapLoading,
                tradingVolumeLargeCapData,
                isDarkMode,
                tradingVolumeChartType,
                setTradingVolumeChartType,
                tradingVolumeExchangeHistoryChartData,
                selectedStock,
              }}
              tradingVolumeMidCap={{
                isTradingVolumeMidCapLoading,
                tradingVolumeMidCapData,
                isDarkMode,
                tradingVolumeChartType,
                setTradingVolumeChartType,
                tradingVolumeExchangeHistoryChartData,
                selectedStock,
              }}
              tradingVolumeSmallCap={{
                isTradingVolumeSmallCapLoading,
                tradingVolumeSmallCapData,
                isDarkMode,
                tradingVolumeChartType,
                setTradingVolumeChartType,
                tradingVolumeExchangeHistoryChartData,
                selectedStock,
              }}
              tradingVolumeMicroCap={{
                isTradingVolumeMicroCapLoading,
                tradingVolumeMicroCapData,
                isDarkMode,
                tradingVolumeChartType,
                setTradingVolumeChartType,
                tradingVolumeExchangeHistoryChartData,
                selectedStock,
              }}
              tradingValueLargeCap={{
                isTradingValueLargeCapLoading,
                tradingValueLargeCapData,
                isDarkMode,
                tradingValueChartType,
                setTradingValueChartType,
                tradingValueExchangeHistoryChartData,
                selectedStock,
              }}
              tradingValueMidCap={{
                isTradingValueMidCapLoading,
                tradingValueMidCapData,
                isDarkMode,
                tradingValueChartType,
                setTradingValueChartType,
                tradingValueExchangeHistoryChartData,
                selectedStock,
              }}
              tradingValueSmallCap={{
                isTradingValueSmallCapLoading,
                tradingValueSmallCapData,
                isDarkMode,
                tradingValueChartType,
                setTradingValueChartType,
                tradingValueExchangeHistoryChartData,
                selectedStock,
              }}
              tradingValueMicroCap={{
                isTradingValueMicroCapLoading,
                tradingValueMicroCapData,
                isDarkMode,
                tradingValueChartType,
                setTradingValueChartType,
                tradingValueExchangeHistoryChartData,
                selectedStock,
              }}
            />
          </div>
          <div className="grid gap-6 grid-cols-1 slg:grid-cols-3 mt-6">
            <TradingVolumeBySector
              isLoading={isTradingVolumeBySectorLoading}
              data={topTradingVolumeBySectorData}
              isDarkMode={isDarkMode}
            />
            <TradingValueBySector
              isLoading={isTradingValueBySectorLoading}
              data={topTradingValueBySectorData}
              isDarkMode={isDarkMode}
            />
            <SectorTrending
              isLoading={isTradingVolumeBySectorLoading}
              tradingVolumeData={topTradingVolumeBySectorData}
              isTradingValueLoading={isTradingValueBySectorLoading}
              tradingValueData={topTradingValueBySectorData}
              isDarkMode={isDarkMode}
              upTrendingData={upTrendingData}
              isUpTrendingDataLoading={isUpTrendingDataLoading}
              onMonthChange={handleMonthChange}
              sectorTrendingDate={sectorTrendingDate}
            />
          </div>
          <div className="mt-6">
            <HighlightStockBySector
              top8VolumeSector={{
                isTradingVolumeBySectorLoading,
                topTradingVolumeBySectorData,
                isDarkMode,
                handleOpenTop10Tooltip,
                chartDataByCode,
                isInvestmentCategoriesLoading,
                authenticated,
                investmentCategories,
                followCompanies,
                saveInvestmentCategory,
                deleteInvestmentCategory,
                investmentCategoriesMessage,
                isOpeningBookmark,
                handleSetIsOpeningBookmark,
                setSelectedChartPeriod,
                handlesSelectedChartPeriodChange,
                selectedChartPeriod,
                setSelectedDataChartModal,
                setChartModalShow,
                isChartDataByCodeLoading,
              }}
              top8ValueSector={{
                isTradingValueBySectorLoading,
                topTradingValueBySectorData,
                isDarkMode,
                handleOpenTop10Tooltip,
                chartDataByCode,
                isInvestmentCategoriesLoading,
                authenticated,
                investmentCategories,
                followCompanies,
                saveInvestmentCategory,
                deleteInvestmentCategory,
                investmentCategoriesMessage,
                isOpeningBookmark,
                handleSetIsOpeningBookmark,
                setSelectedChartPeriod,
                handlesSelectedChartPeriodChange,
                selectedChartPeriod,
                setSelectedDataChartModal,
                setChartModalShow,
                isChartDataByCodeLoading,
              }}
            />
          </div>

          <div className="mt-6">
            <HighlightByStockUp
              isTop10GoUpLoading={isTop10GoUpLoading}
              top10GoUpData={top10GoUpData}
              isTop10GoDownLoading={isTop10GoDownLoading}
              top10GoDownData={top10GoDownData}
              handleOpenTop10GoUpGoDownTooltip={handleOpenTop10Tooltip}
              isDarkMode={isDarkMode}
              top10GoUpGoDownChartData={chartDataByCode}
              isInvestmentCategoriesLoading={isInvestmentCategoriesLoading}
              authenticated={authenticated}
              investmentCategories={investmentCategories}
              followCompanies={followCompanies}
              saveInvestmentCategory={saveInvestmentCategory}
              deleteInvestmentCategory={deleteInvestmentCategory}
              investmentCategoriesMessage={investmentCategoriesMessage}
              isOpeningBookmark={isOpeningBookmark}
              handleSetIsOpeningBookmark={handleSetIsOpeningBookmark}
              setSelectedChartPeriod={setSelectedChartPeriod}
              handlesSelectedChartPeriodChange={
                handlesSelectedChartPeriodChange
              }
              selectedChartPeriod={selectedChartPeriod}
              setSelectedDataChartModal={setSelectedDataChartModal}
              setChartModalShow={setChartModalShow}
              isChartDataByCodeLoading={isChartDataByCodeLoading}
            />
          </div>

          <div className="mt-6">
            <MarketNewsSection
              isMarketNewsLoading={isMarketNewsLoading}
              marketNews={marketNews}
            />
          </div>
        </div>
      </Styles.Wrapper>
    </Layout>
  );
};

export default Dashboard;
